import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS } from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import EmailTemplateList from './EmailTemplateList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class EmailTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.emailTemplateState.pageSize,
                pageIndex: this.props.emailTemplateState.pageIndex,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.EMAIL_TEMPLATE);
        this.props.getEmailTemplates(this.state.filters);
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, emailTemplates } = this.props.emailTemplateState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'emailTemplate'}
                        titleHeader={t('navigation.emailTemplate')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.EMAIL_TEMPLATE.CREATE.path}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <EmailTemplateList loading={isFetching}
                        permisions={permisionActions}
                        emailTemplates={emailTemplates}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteEmailTemplate={this.onDeleteEmailTemplate}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getEmailTemplates(newFilters);
    };

    onDeleteEmailTemplate = (item) => {
        this.props.deleteEmailTemplate(item, {
            filters: {
                pageSize: this.props.emailTemplateState.pageSize,
                pageIndex: this.props.emailTemplateState.pageIndex
            }
        });
    }

    onChangeLanguage = (language) => {
        this.props.getEmailTemplates(this.state.filters)
    }


}
